<template>
  <div>
    <q-dialog
      :visible.sync="isVisible"
      :title="dialogType ? '修改产品属性' : '产品信息同步'"
      width="980px"
      :innerScroll="false"
      :showFooter="false"
      @close="handleClose"
      v-loading.fullscreen.lock="loading"
    >
      <el-form :model="formData" :rules="rules" label-width="120px" ref="formRef" size="small" class="form-content">
        <el-row>
          <el-col :span="8" v-if="!dialogType">
            <el-form-item label="原产品编号：" prop="productCodeSource">
              <el-input @blur="getProductNameSource" style="width: 200px" v-model="formData.productCodeSource" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!dialogType">
            <el-form-item :show-overflow-tooltip="true" label="原产品名称：">
              <el-tooltip effect="dark" :content="productNameSource">
                <div class="wrap_tooltip">
                  <span>{{ productNameSource }}</span>
                </div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="!dialogType ? '新产品编号：' : '产品编号：'" prop="productCode">
              <el-input @blur="getforCodes" style="width: 200px" v-model="formData.productCode" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :show-overflow-tooltip="true" :label="!dialogType ? '新产品名称：' : '产品名称：'">
              <el-tooltip effect="dark" :content="newName">
                <div class="wrap_tooltip">
                  <span>{{ newName }}</span>
                </div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="风格：">
              <el-select v-model="formData.style" :disabled="showFlag" size="small" placeholder="请选择" filterable style="width: 200px" clearable>
                <el-option v-for="(item, index) in styles" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="空间：">
              <el-select v-model="formData.space" :disabled="showFlag" filterable size="small" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in spaces" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="材质：">
              <el-select v-model="formData.material" :disabled="showFlag" filterable size="small" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in materials" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用对象：">
              <el-select v-model="formData.useObject" :disabled="showFlag" size="small" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in useObjects" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品类细分：">
              <el-select v-model="formData.category" :disabled="showFlag" filterable clearable size="small" placeholder="请选择">
                <el-option v-for="(item, index) in categorys" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="功能：">
              <el-input v-model.trim="formData.functionality" placeholder="请输入功能"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系列：">
              <el-select v-model="formData.series" :disabled="showFlag" filterable clearable size="small" placeholder="请选择">
                <el-option v-for="(item, index) in seriess" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属板块：">
              <el-select v-model="formData.plate" :disabled="showFlag" size="small" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in plates" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="尺寸：">
              <el-input v-model="formData.productSize" size="small" style="width: 150px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="颜色：">
              <el-select v-model="formData.color" clearable :disabled="showFlag" size="small" filterable placeholder="请选择">
                <el-option v-for="(item, index) in colors" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否形象款：">
              <el-select v-model="formData.imageStyleFlag" clearable>
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属类型：">
              <el-select v-model="formData.type" @change="handleTypeChange" clearable>
                <el-option v-for="(item, index) in types" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属店铺：" prop="shopId">
              <el-select
                v-model="formData.shopId"
                multiple
                collapse-tags
                clearable
                filterable
                :multiple-limit="formData.type !== '核心A' ? 0 : 1"
                :disabled="!formData.type"
              >
                <el-option v-for="(item, index) in shopOptions" :key="index" :label="item.shopName" :value="item.shopId"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dialogType">
            <el-form-item label="是否含松木：">
              <el-select v-model="formData.containsPine" clearable>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="适配床垫：">
              <el-input v-model.trim="formData.adapterMattress" placeholder="适配床垫" :disabled="categoryType === '0'" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签：">
              <el-input v-model.trim="formData.productLabel" placeholder="标签" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上市时间：">
              <el-date-picker v-model="formData.upDate" type="date" :disabled="disabledTime" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="面料：">
              <el-input v-model.trim="formData.fabric" placeholder="面料" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品供应商：">
              <el-input v-model.trim="formData.supplier" placeholder="产品供应商" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="填充物：">
              <el-select v-model="formData.filler" filterable clearable>
                <el-option v-for="(item, index) in proudctFillerList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="饰面工艺：">
              <el-select v-model="formData.finishingProcess" clearable>
                <el-option v-for="(item, index) in proudctFinishingProcessList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品类型：">
              <el-select v-model="formData.productType" clearable>
                <el-option v-for="(item, index) in productTypeList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="台面材质：">
              <el-select v-model="formData.tableMaterial" clearable>
                <el-option v-for="(item, index) in proudctTableMaterialList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="脚类型：">
              <el-select v-model="formData.footType" clearable>
                <el-option v-for="(item, index) in proudctFootTypeList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="拉手类型：">
              <el-select v-model="formData.handleType" clearable>
                <el-option v-for="(item, index) in proudctHandleTypeList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="lifeCycle">
              <template slot="label">
                <span class="label-with-tip">
                  生产周期
                  <el-tooltip content="小件代发产品的生产周期" placement="top">
                    <i class="el-icon-question tip-icon"></i>
                  </el-tooltip>
                  ：
                </span>
              </template>
              <el-input-number
                v-model="formData.lifeCycle"
                :min="0"
                :max="100"
                :precision="0"
                :step="1"
                :controls="false"
                step-strictly
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="送装类型：">
              <el-select v-model="formData.deliveryType" clearable filterable placeholder="请选择">
                <el-option v-for="item in deliveryTypeOptions" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备货类型：">
              <el-select v-model="formData.stockType" clearable filterable placeholder="请选择">
                <el-option v-for="item in stockTypeOptions" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 自定义底部按钮 -->
      <div class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
        <el-button type="success" @click="handleNotifyOpen" :loading="loading" v-show="dialogType" v-permission="'ec-pc-new#productBaseattr#noticeBtn'">确定并通知店铺</el-button>
      </div>
    </q-dialog>
    <!-- 通知店铺弹窗 -->
    <notify-store-dialog :visible.sync="showNotifyDialog" v-if="showNotifyDialog" @confirm="handleNotifyConfirm" />
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog'

export default {
  name: 'ProductAttrSyncDialog',
  components: { notifyStoreDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: Boolean,
      default: false // false=同步, true=编辑
    },
    row: {
      type: Object,
      default: null
    },
    shopOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    const checkTypesValid = (rule, value, callback, form) => {
      if (form.type) {
        if (!value || (value && !value.length)) {
          callback(new Error('所属类型有值，所属店铺不能为空。'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      showFlag: false,
      formData: {
        productCode: '',
        lifeCycle: undefined,
        deliveryType: '',
        stockType: ''
      },
      newName: '',
      productNameSource: '',
      categoryType: '',
      // 下拉选项
      styles: [],
      spaces: [],
      materials: [],
      useObjects: [],
      categorys: [],
      seriess: [],
      plates: [],
      colors: [],
      types: [],
      proudctFillerList: [],
      proudctFinishingProcessList: [],
      productTypeList: [],
      proudctTableMaterialList: [],
      proudctFootTypeList: [],
      proudctHandleTypeList: [],
      deliveryTypeOptions: ['公司送装', '供应商送装', '无需送装'],
      stockTypeOptions: ['现货值', '备货值'],
      disabledTime: true,
      // 通知相关
      showNotifyDialog: false,
      isNotify: false,
      notifyForm: {},
      rules: {
        productCode: [{ required: true, message: '请输入产品编号', trigger: 'blur' }],
        productCodeSource: [{ required: true, message: '请输入产品编号', trigger: 'blur' }],
        shopId: [
          {
            validator: (rule, value, callback) => {
              checkTypesValid(rule, value, callback, this.formData)
            }
          }
        ]
      }
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  mounted () {
    this.loadEnumOptions()
    this.loadTypes()
    this.checkTimePermission()
    this.initDialog()
  },
  methods: {
    getDefaultFormData () {
      return {
        productCode: '',
        lifeCycle: undefined,
        deliveryType: '',
        stockType: ''
      }
    },
    normalizeFormData (formData = {}) {
      return {
        ...this.getDefaultFormData(),
        ...formData,
        lifeCycle: formData.lifeCycle || undefined
      }
    },
    initDialog () {
      this.showFlag = false
      this.newName = ''
      this.productNameSource = ''
      this.categoryType = ''

      if (this.dialogType && this.row) {
        // 编辑模式：填充当前行数据
        this.formData = this.normalizeFormData(JSON.parse(JSON.stringify(this.row)))
        this.$set(this.formData, 'imageStyleFlag', this.row.imageStyleFlag)
        this.newName = this.row.productName
        this.categoryType = this.row.categoryType
      } else {
        // 同步模式：清空表单
        this.formData = this.getDefaultFormData()
      }
    },
    handleClose () {
      this.isVisible = false
    },
    handleSubmit () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$message('提交参数有误')
          return
        }
        this.loading = true
        if (!this.dialogType) {
          // 同步信息
          this.formData.productName = this.newName
          this.$q.product
            .copy({ data: JSON.stringify(this.formData) })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message)
                this.handleClose()
                this.$emit('success')
              } else {
                this.$message.error(res.message)
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          // 编辑
          this.formData.productName = this.newName
          // 构建请求数据
          let requestData = { ...this.formData }
          // 如果需要通知，将通知参数整合到请求数据中
          if (this.isNotify) {
            requestData = {
              ...this.formData,
              ...this.notifyForm
            }
          }
          this.$q.product
            .updateForProduct({ data: JSON.stringify(requestData) })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success('修改成功')
                this.handleClose()
                this.$emit('success')
                // 通知成功后刷新菜单数量
                if (this.isNotify && this.notifyForm.noticeTime == 0) {
                  this.$store.dispatch('menu/getMenusNum', {}, { root: true })
                }
              } else {
                this.$message.error(res.message)
              }
            })
            .finally(() => {
              this.loading = false
              this.isNotify = false
            })
        }
      })
    },
    // 打开通知弹窗
    handleNotifyOpen () {
      this.$refs.formRef.validate((valid) => {
        if (!valid || !this.formData.productName) {
          this.$message('提交参数有误')
          return
        }
        this.showNotifyDialog = true
        this.isNotify = false
      })
    },
    // 通知弹窗确认回调
    handleNotifyConfirm (data) {
      this.isNotify = true
      this.notifyForm = data
      this.handleSubmit()
    },

    getforCodes () {
      if (!this.formData.productCode) {
        this.newName = ''
        return
      }
      this.$q.product.getProductForCode({ params: { code: this.formData.productCode } }).then((res) => {
        if (res.code == 200 && res.data.length) {
          this.newName = res.data[0].name
        } else {
          Notification.error({
            message: '新产品编码不存在！'
          })
          this.newName = ''
        }
      })
    },
    getProductNameSource () {
      if (!this.formData.productCodeSource) {
        this.productNameSource = ''
        this.formData = {
          ...this.getDefaultFormData(),
          productCode: this.formData.productCode
        }
        return
      }
      this.$refs.formRef.clearValidate()
      this.$q.product
        .listPage({
          data: {
            filterData: {
              accurateProductCode: this.formData.productCodeSource
            },
            pageSize: 30,
            pageNum: 1
          }
        })
        .then((res) => {
          if (res.code == 200 && res.data.records.length) {
            const productCode = this.formData.productCode
            this.productNameSource = res.data.records[0].productName
            this.categoryType = res.data.records[0].categoryType
            this.formData = this.normalizeFormData(res.data.records[0])
            this.$set(this.formData, 'productCodeSource', res.data.records[0].productCode)
            this.$set(this.formData, 'productCode', productCode)
          } else {
            Notification.error({
              message: '原产品编码不存在！'
            })
            this.$set(this.formData, 'upDate', '')
            this.productNameSource = ''
            this.categoryType = ''
          }
        })
    },
    handleTypeChange () {
      this.$set(this.formData, 'newPushTimes', '')
      this.$set(this.formData, 'shopId', [])
    },
    handlelifeCycleChange (value) {
      this.$set(this.formData, 'lifeCycle', this.normalizelifeCycleValue(value))
    },
    loadEnumOptions () {
      this.$q.product.getPoductforEnum().then((res) => {
        if (res.code == 200) {
          this.styles = res.data.style
          this.spaces = res.data.space
          this.materials = res.data.material
          this.useObjects = res.data.useObject
          this.categorys = res.data.category
          this.seriess = res.data.series
          this.plates = res.data.plate
          this.colors = res.data.color
          this.proudctFillerList = res.data.proudctFillerList
          this.proudctFinishingProcessList = res.data.proudctFinishingProcessList
          this.productTypeList = res.data.productTypeList
          this.proudctTableMaterialList = res.data.proudctTableMaterialList
          this.proudctFootTypeList = res.data.proudctFootTypeList
          this.proudctHandleTypeList = res.data.proudctHandleTypeList
        }
      })
    },
    loadTypes () {
      this.$q.product.getType().then((res) => {
        this.types = res.data
      })
    },
    checkTimePermission () {
      const buttonJurisdiction = JSON.parse(localStorage.getItem('permitList'))
      const Jurisdiction = 'ec-pc-new$goodsManage$basicInformationManagement$productBaseattr$ListingTime'
      this.disabledTime = !buttonJurisdiction.includes(Jurisdiction)
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrap_tooltip {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  height: 28px;
}

.form-content {
  padding-top: 15px;
}

>>> .form-content .el-date-editor,
>>> .form-content .el-select,
>>> .form-content .el-input-number,
>>> .form-content .el-input {
  width: 170px !important;
}

.label-with-tip {
  display: inline-flex;
  align-items: center;
}

.tip-icon {
  margin-left: 4px;
  color: #606266;
  cursor: pointer;
}

>>> .form-content .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

>>> .form-content .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px;
}

>>> .el-row {
  display: flex;
  flex-wrap: wrap;
}

.dialog-footer {
  text-align: center;
  padding: 30px 0 10px 0;
}
</style>
